import { render, staticRenderFns } from "./SubuserChangePassword.vue?vue&type=template&id=08d0a030"
import script from "./SubuserChangePassword.vue?vue&type=script&lang=js"
export * from "./SubuserChangePassword.vue?vue&type=script&lang=js"
import style0 from "./SubuserChangePassword.vue?vue&type=style&index=0&id=08d0a030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports